import * as React from "react";
const SvgLetzteSeite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="LetzteSeite">
    <path
      fill="currentColor"
      d="m50.61 205.26 123.68-71.41c4.51-2.6 4.51-9.1 0-11.7L50.61 50.74c-4.51-2.6-10.14.65-10.14 5.85v142.82c0 5.2 5.63 8.45 10.14 5.85m4.86-134.39L154.43 128l-98.96 57.13V70.86Z"
    />
    <rect x={200.53} y={44.31} fill="currentColor" rx={7.5} ry={7.5} />
  </svg>
);
export default SvgLetzteSeite;
